import React, { useState, useEffect } from "react";
import { Divider, Image, Descriptions, Tag } from "antd";
import { Container } from "react-bootstrap";
import Moment from "react-moment";
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CashBoxReceipt = function CashBoxReceipt(_ref) {
  var _ref$transaction = _ref.transaction,
    transaction = _ref$transaction === void 0 ? null : _ref$transaction;
  return /*#__PURE__*/_jsx(Container, {
    children: transaction && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: "center"
      },
      children: [/*#__PURE__*/_jsx(Image, {
        src: Common.businessAccount.logo,
        fallback: "drawables/ss.png",
        width: "180px"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: ["R\xE9\xE7u de caisse N\u1D52", "00" + transaction.id]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Descriptions, {
        size: "small",
        layout: "vertical",
        bordered: true,
        column: 1,
        items: [{
          key: '1',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Type"
          }),
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [transaction.operation_type == 0 && /*#__PURE__*/_jsx(Tag, {
              color: "#f50",
              children: "Sortie"
            }), transaction.operation_type == 1 && /*#__PURE__*/_jsx(Tag, {
              color: "#346C4C",
              children: "Entr\xE9e"
            })]
          })
        }, {
          key: '2',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Date"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY"
          })
        }, {
          key: '3',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Montant"
          }),
          children: transaction.amount.toLocaleString("Fr")
        }, {
          key: '4',
          label: /*#__PURE__*/_jsx("div", {
            style: {
              fontWeigth: "bold",
              textAlign: "center"
            },
            children: "Agent"
          }),
          children: Common.currentUser.prenom + " " + Common.currentUser.nom
        }]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
    })
  });
};
export default CashBoxReceipt;